import { motion } from 'framer-motion';
import { Activity, Cpu, Sparkles, Zap, ExternalLink } from 'lucide-react';

export function Header({ health, latencyMs }) {
  const ok = health?.ok;
  const models = health?.data?.models;
  const version = health?.data?.version;

  return (
    <motion.header
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="sticky top-0 z-30 border-b border-border-subtle/70 bg-bg-base/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-6 px-6 py-3">
        <div className="flex items-center gap-3">
          <div className="relative">
            <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-accent-cyan/30 to-accent-orange/30 blur-md" />
            <div className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-bg-elevated to-bg-surface ring-1 ring-border-strong">
              <Sparkles className="h-4 w-4 text-accent-cyan-light" strokeWidth={2.4} />
            </div>
          </div>
          <div className="flex flex-col leading-tight">
            <div className="font-display text-base font-semibold tracking-tight text-ink-primary">
              BrackenW3 <span className="text-gradient-cyan-orange">Orchestrator</span>
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-ink-dim">
              multi-agent · synthesis · cost-aware
            </div>
          </div>
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <div className="chip-cyan">
            <Cpu className="h-3 w-3" />
            <span>{models ?? '—'} models</span>
          </div>
          <div className="chip">
            <Zap className="h-3 w-3" />
            <span>v{version ?? '—'}</span>
          </div>
          <div className={`chip ${ok ? 'border-signal-ok/40 text-signal-ok' : 'border-signal-err/40 text-signal-err'}`}>
            <span className="relative flex h-2 w-2">
              {ok && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-signal-ok opacity-60" />}
              <span className={`relative inline-flex h-2 w-2 rounded-full ${ok ? 'bg-signal-ok' : 'bg-signal-err'}`} />
            </span>
            <span>{ok ? 'gateway live' : 'gateway down'}</span>
          </div>
          {latencyMs != null && (
            <div className="chip">
              <Activity className="h-3 w-3" />
              <span>{latencyMs}ms</span>
            </div>
          )}
        </div>

        <a
          href="https://ai-gateway.will-i-bracken.workers.dev/health"
          target="_blank"
          rel="noreferrer"
          className="hidden items-center gap-1.5 font-mono text-[11px] text-ink-dim hover:text-accent-cyan-light lg:flex"
        >
          ai-gateway.will-i-bracken.workers.dev
          <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </motion.header>
  );
}
